/* jslint esversion: 6 */
/**
 * Max-Width iFrame
 *
 * Enable iFrames to scale responsively within parent.
 *
 * @requires _max-width-iframe.scss
 *
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
	scope       : $('.wysiwyg'), // $('main'),
	// selector    : 'iframe',
	selectors   : [
		'iframe[src*="youtube.com"]',
		'iframe[src*="youtu.be"]',
		'iframe[src*="vimeo.com"]',
	],
	setPadding  : true, // true, false (use styles)
	setMaxWidth : true, // true, false, '300px'
};

function init() {

	wrapIFrames();
}

function wrapIFrames() {
	var selector = null; // s.selector;

	if (s.selectors.length) {
		selector = '';

		s.selectors.forEach(function(value, key) {
			if (key) {
				selector += ', ';
			}

			selector += value;
		});
	}

	s.scope.find(selector).each(function(index, element) {
		var $element = $(element);

		var width    = $element.attr('width');
		var height   = $element.attr('height');
		var padding  = (height / width * 100);
		var maxWidth = (typeof s.setMaxWidth !== 'boolean' ? s.setMaxWidth : width + 'px');

		var containerStyle = [];
		var innerStyle = [];

		if (s.setMaxWidth && maxWidth) {
			containerStyle.push('max-width: ' + maxWidth + ';');
		}

		if (s.setPadding && padding) {
			innerStyle.push('padding-top: ' + padding + '%;');
		}

		var containerStyleAttribute = (containerStyle.length ? ' style="' + containerStyle.join(' ') + '"' : '');
		var innerStyleAttribute     = (innerStyle.length     ? ' style="' + innerStyle.join(' ') + '"' : '');

		if ($element.parent('p').length) {
			$element.unwrap();
		}

		$element
			.attr('allowtransparency', true)
			.wrap('<div class="max-width-iframe"' + containerStyleAttribute + '><div class="max-width-iframe__inner"' + innerStyleAttribute + '></div></div>');
	});
}

export {init as default};
